/* ═══════════════════════════════════════════════════
   Tealibere Review Engine — Loox-Style
   Renders reviews, stars, distribution bars,
   sort/filter, photo lightbox, Google Schema,
   product card star badges
   ═══════════════════════════════════════════════════ */
(function(){
  'use strict';

  /* ── SVG Star Templates ── */
  const STAR_FULL = '<svg class="tl-star" viewBox="0 0 24 24" fill="#f5a623" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14 2 9.27l6.91-1.01z"/></svg>';
  const STAR_HALF = '<svg class="tl-star" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><defs><linearGradient id="tl-half-star"><stop offset="50%" stop-color="#f5a623"/><stop offset="50%" stop-color="#ddd"/></linearGradient></defs><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14 2 9.27l6.91-1.01z" fill="url(#tl-half-star)"/></svg>';
  const STAR_EMPTY = '<svg class="tl-star" viewBox="0 0 24 24" fill="#ddd" xmlns="http://www.w3.org/2000/svg"><path d="M12 2l3.09 6.26L22 9.27l-5 4.87L18.18 22 12 18.27 5.82 22 7 14.14 2 9.27l6.91-1.01z"/></svg>';

  const PER_PAGE = 5;
  const LOCALE = ((document.documentElement.lang || '').split('-')[0] || 'en').toLowerCase();
  const I18N = {
    en: {
      close: 'Close',
      loadError: 'Reviews could not be loaded. Please try again.',
      retry: 'Try again',
      reviewPhoto: 'Review photo',
      verified: 'Verified',
      foundHelpful: 'found this helpful',
      helpful: 'Helpful?',
      customerReviews: 'Customer Reviews',
      basedOn: 'Based on',
      review: 'review',
      reviews: 'reviews',
      star: 'star',
      newest: 'Newest',
      highestRated: 'Highest Rated',
      lowestRated: 'Lowest Rated',
      all: 'All',
      noReviews: 'No reviews match this filter.',
      outOfFive: 'out of 5 stars',
      reviewsAcross: 'reviews across',
      products: 'products',
      browseByProduct: 'Browse by Product',
      reviewsFor: 'Reviews for',
      allReviews: 'All Reviews',
      viewProduct: 'View Product',
      monthsShort: ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec']
    },
    es: {
      close: 'Cerrar',
      reviewPhoto: 'Foto de la resena',
      verified: 'Verificado',
      foundHelpful: 'lo encontraron util',
      helpful: 'Te resulto util?',
      customerReviews: 'Resenas de clientes',
      basedOn: 'Basado en',
      review: 'resena',
      reviews: 'resenas',
      star: 'estrella',
      newest: 'Mas recientes',
      highestRated: 'Mejor valoradas',
      lowestRated: 'Peor valoradas',
      all: 'Todas',
      noReviews: 'No hay resenas que coincidan con este filtro.',
      outOfFive: 'de 5 estrellas',
      reviewsAcross: 'resenas en',
      products: 'productos',
      browseByProduct: 'Explorar por producto',
      reviewsFor: 'Resenas de',
      allReviews: 'Todas las resenas',
      viewProduct: 'Ver producto',
      monthsShort: ['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic']
    },
    it: {
      close: 'Chiudi',
      reviewPhoto: 'Foto della recensione',
      verified: 'Verificato',
      foundHelpful: 'lo hanno trovato utile',
      helpful: 'Ti e stato utile?',
      customerReviews: 'Recensioni dei clienti',
      basedOn: 'Basato su',
      review: 'recensione',
      reviews: 'recensioni',
      star: 'stella',
      newest: 'Piu recenti',
      highestRated: 'Valutazione piu alta',
      lowestRated: 'Valutazione piu bassa',
      all: 'Tutte',
      noReviews: 'Nessuna recensione corrisponde a questo filtro.',
      outOfFive: 'su 5 stelle',
      reviewsAcross: 'recensioni su',
      products: 'prodotti',
      browseByProduct: 'Sfoglia per prodotto',
      reviewsFor: 'Recensioni per',
      allReviews: 'Tutte le recensioni',
      viewProduct: 'Vedi prodotto',
      monthsShort: ['gen','feb','mar','apr','mag','giu','lug','ago','set','ott','nov','dic']
    },
    fr: {
      close: 'Fermer',
      loadError: 'Impossible de charger les avis. Veuillez réessayer.',
      retry: 'Réessayer',
      reviewPhoto: "Photo de l'avis",
      verified: 'Verifie',
      foundHelpful: 'personnes ont trouve cela utile',
      helpful: 'Utile ?',
      customerReviews: 'Avis clients',
      basedOn: 'Base sur',
      review: 'avis',
      reviews: 'avis',
      star: 'etoile',
      newest: 'Les plus recents',
      highestRated: 'Les mieux notes',
      lowestRated: 'Les moins bien notes',
      all: 'Tous',
      noReviews: 'Aucun avis ne correspond a ce filtre.',
      outOfFive: 'sur 5 etoiles',
      reviewsAcross: 'avis sur',
      products: 'produits',
      browseByProduct: 'Parcourir par produit',
      reviewsFor: 'Avis pour',
      allReviews: 'Tous les avis',
      viewProduct: 'Voir le produit',
      monthsShort: ['janv.','fevr.','mars','avr.','mai','juin','juil.','aout','sept.','oct.','nov.','dec.']
    },
    de: {
      close: 'Schliessen',
      loadError: 'Bewertungen konnten nicht geladen werden. Bitte versuchen Sie es erneut.',
      retry: 'Erneut versuchen',
      reviewPhoto: 'Bewertungsfoto',
      verified: 'Verifiziert',
      foundHelpful: 'fanden dies hilfreich',
      helpful: 'Hilfreich?',
      customerReviews: 'Kundenbewertungen',
      basedOn: 'Basierend auf',
      review: 'Bewertung',
      reviews: 'Bewertungen',
      star: 'Stern',
      newest: 'Neueste',
      highestRated: 'Am besten bewertet',
      lowestRated: 'Am niedrigsten bewertet',
      all: 'Alle',
      noReviews: 'Keine Bewertungen entsprechen diesem Filter.',
      outOfFive: 'von 5 Sternen',
      reviewsAcross: 'Bewertungen uber',
      products: 'Produkte',
      browseByProduct: 'Nach Produkt durchsuchen',
      reviewsFor: 'Bewertungen fuer',
      allReviews: 'Alle Bewertungen',
      viewProduct: 'Produkt ansehen',
      monthsShort: ['Jan.','Feb.','Marz','Apr.','Mai','Juni','Juli','Aug.','Sept.','Okt.','Nov.','Dez.']
    },
    ja: {
      close: '閉じる',
      reviewPhoto: 'レビュー写真',
      verified: '認証済み',
      foundHelpful: '人が参考になったと回答',
      helpful: '参考になりましたか？',
      customerReviews: 'お客様レビュー',
      basedOn: '基づくレビュー数',
      review: '件のレビュー',
      reviews: '件のレビュー',
      star: '星',
      newest: '新着順',
      highestRated: '評価が高い順',
      lowestRated: '評価が低い順',
      all: 'すべて',
      noReviews: 'この条件に一致するレビューはありません。',
      outOfFive: '5つ星中',
      reviewsAcross: '件のレビュー /',
      products: '商品',
      browseByProduct: '商品別に見る',
      reviewsFor: 'レビュー対象',
      allReviews: 'すべてのレビュー',
      viewProduct: '商品を見る',
      monthsShort: ['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月']
    },
    ko: {
      close: '닫기',
      reviewPhoto: '리뷰 사진',
      verified: '인증됨',
      foundHelpful: '명이 도움이 된다고 답했습니다',
      helpful: '도움이 되었나요?',
      customerReviews: '고객 리뷰',
      basedOn: '기준 리뷰 수',
      review: '개 리뷰',
      reviews: '개 리뷰',
      star: '별',
      newest: '최신순',
      highestRated: '평점 높은순',
      lowestRated: '평점 낮은순',
      all: '전체',
      noReviews: '이 필터와 일치하는 리뷰가 없습니다.',
      outOfFive: '5점 만점',
      reviewsAcross: '개 리뷰 /',
      products: '상품',
      browseByProduct: '상품별 보기',
      reviewsFor: '리뷰 대상',
      allReviews: '전체 리뷰',
      viewProduct: '상품 보기',
      monthsShort: ['1월','2월','3월','4월','5월','6월','7월','8월','9월','10월','11월','12월']
    },
    nl: {
      close: 'Sluiten',
      reviewPhoto: 'Reviewfoto',
      verified: 'Geverifieerd',
      foundHelpful: 'vonden dit nuttig',
      helpful: 'Nuttig?',
      customerReviews: 'Klantbeoordelingen',
      basedOn: 'Gebaseerd op',
      review: 'beoordeling',
      reviews: 'beoordelingen',
      star: 'ster',
      newest: 'Nieuwste',
      highestRated: 'Hoogst beoordeeld',
      lowestRated: 'Laagst beoordeeld',
      all: 'Alle',
      noReviews: 'Geen beoordelingen gevonden voor dit filter.',
      outOfFive: 'van 5 sterren',
      reviewsAcross: 'beoordelingen over',
      products: 'producten',
      browseByProduct: 'Bladeren per product',
      reviewsFor: 'Beoordelingen voor',
      allReviews: 'Alle beoordelingen',
      viewProduct: 'Bekijk product',
      monthsShort: ['jan','feb','mrt','apr','mei','jun','jul','aug','sep','okt','nov','dec']
    }
  };
  const TEXT = I18N[LOCALE] || I18N.en;

  function t(key) {
    return TEXT[key] || I18N.en[key] || key;
  }

  function reviewWord(count) {
    return count === 1 ? t('review') : t('reviews');
  }

  function localizedReviewField(rev, field) {
    var i18n = rev[field + '_i18n'];
    if (i18n && i18n[LOCALE]) return i18n[LOCALE];

    var legacy = rev[field + '_' + LOCALE];
    if (legacy) return legacy;

    if (rev.i18n && rev.i18n[LOCALE] && rev.i18n[LOCALE][field]) {
      return rev.i18n[LOCALE][field];
    }

    return rev[field] || '';
  }

  function bindHelpfulButtons(container) {
    container.querySelectorAll('.tl-rev-helpful').forEach(function(button) {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', function() {
        this.classList.toggle('tl-rev-helpful--voted');
        var span = this.querySelector('span');
        var count = parseInt(span.dataset.c || 0, 10);
        if (this.classList.contains('tl-rev-helpful--voted')) {
          count++;
        } else {
          count--;
        }
        span.dataset.c = count;
        span.textContent = count > 0 ? count + ' ' + this.dataset.foundHelpful : this.dataset.helpfulEmpty;
      });
    });
  }

  /* ── Helpers ── */
  function stars(rating, sizeClass) {
    sizeClass = sizeClass || '';
    let html = '<span class="tl-stars">';
    for (let i = 1; i <= 5; i++) {
      if (i <= Math.floor(rating)) {
        html += STAR_FULL.replace('class="tl-star"', 'class="tl-star ' + sizeClass + '"');
      } else if (i - 0.5 <= rating) {
        html += STAR_HALF.replace('class="tl-star"', 'class="tl-star ' + sizeClass + '"');
      } else {
        html += STAR_EMPTY.replace('class="tl-star"', 'class="tl-star ' + sizeClass + '"');
      }
    }
    html += '</span>';
    return html;
  }

  function cardStars(rating) {
    var rounded = Math.round((rating || 0) * 10) / 10;
    return '<span class="tl-card-stars-text" aria-hidden="true">★★★★★</span>' +
      ' <span class="tl-badge-avg">' + rounded.toFixed(1) + '</span>';
  }

  // Review text comes from external exports (review-app CSV/XLSX), so it is
  // untrusted input. Every value interpolated into innerHTML must be escaped.
  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function initials(name) {
    return name.replace(/[^a-zA-Z\u4e00-\u9fff ]/g, '').split(' ')
      .map(function(w){ return w.charAt(0); }).join('').substring(0, 2).toUpperCase() || '?';
  }

  function formatDate(d) {
    var months = TEXT.monthsShort || I18N.en.monthsShort;
    var parts = d.split('-');
    return months[parseInt(parts[1], 10) - 1] + ' ' + parseInt(parts[2], 10) + ', ' + parts[0];
  }

  function getHandle() {
    // Try meta tag first
    var meta = document.querySelector('meta[property="og:url"]');
    if (meta) {
      var m = meta.content.match(/\/products\/([^?#\/]+)/);
      if (m) return m[1];
    }
    // Try URL
    var urlMatch = window.location.pathname.match(/\/products\/([^?#\/]+)/);
    if (urlMatch) return urlMatch[1];
    return null;
  }

  function getProductData() {
    if (!window.TL_REVIEWS) return null;
    var handle = getHandle();
    if (!handle) return null;
    return window.TL_REVIEWS[handle] || null;
  }

  /* ── Lightbox ── */
  var lightboxReturnFocus = null;

  function closeLightbox() {
    var lb = document.getElementById('tl-rev-lightbox');
    if (!lb) return;
    lb.classList.remove('tl-rev-lightbox--open');
    if (lightboxReturnFocus && document.contains(lightboxReturnFocus)) {
      lightboxReturnFocus.focus();
    }
    lightboxReturnFocus = null;
  }

  function createLightbox() {
    if (document.getElementById('tl-rev-lightbox')) return;
    var lb = document.createElement('div');
    lb.id = 'tl-rev-lightbox';
    lb.className = 'tl-rev-lightbox';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', t('reviewPhoto'));
    lb.innerHTML = '<button class="tl-rev-lightbox-close" aria-label="' + t('close') + '">&times;</button><img alt="' + t('reviewPhoto') + '">';
    lb.addEventListener('click', function(e) {
      if (e.target === lb || e.target.classList.contains('tl-rev-lightbox-close')) {
        closeLightbox();
      }
    });
    lb.addEventListener('keydown', function(e) {
      if (!lb.classList.contains('tl-rev-lightbox--open')) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        closeLightbox();
      } else if (e.key === 'Tab') {
        e.preventDefault();
        lb.querySelector('.tl-rev-lightbox-close').focus();
      }
    });
    document.body.appendChild(lb);
  }

  function openLightbox(src, alt) {
    var lb = document.getElementById('tl-rev-lightbox');
    if (!lb) return;
    var image = lb.querySelector('img');
    image.src = src;
    image.alt = alt || t('reviewPhoto');
    lightboxReturnFocus = document.activeElement;
    lb.classList.add('tl-rev-lightbox--open');
    lb.querySelector('.tl-rev-lightbox-close').focus();
  }

  /* ── Review Card HTML ── */
  function reviewCard(rev) {
    var title = localizedReviewField(rev, 'title');
    var body = localizedReviewField(rev, 'body');
    var html = '<div class="tl-rev-card">';
    html += '<div class="tl-rev-card-header">';
    html += '<div class="tl-rev-avatar">' + initials(rev.author) + '</div>';
    html += '<div class="tl-rev-author-info">';
    html += '<div class="tl-rev-author-name">' + esc(rev.author);
    html += '</div>';
    if (rev.loc) html += '<div class="tl-rev-author-loc">' + esc(rev.loc) + '</div>';
    html += '</div>';
    html += '<div class="tl-rev-date">' + formatDate(rev.date) + '</div>';
    html += '</div>';
    html += '<div class="tl-rev-card-stars">' + stars(rev.rating) + '</div>';
    if (title) html += '<div class="tl-rev-card-title">' + esc(title) + '</div>';
    html += '<div class="tl-rev-card-body">' + esc(body) + '</div>';
    if (rev.photos && rev.photos.length) {
      html += '<div class="tl-rev-photos">';
      rev.photos.forEach(function(p) {
        html += '<img class="tl-rev-photo" src="' + esc(p) + '" alt="' + t('reviewPhoto') + '" loading="lazy" tabindex="0" role="button" onclick="window.TealibereReviews.openLightbox(this.src,this.alt)" onkeydown="if(event.key===\'Enter\'||event.key===\' \'){event.preventDefault();window.TealibereReviews.openLightbox(this.src,this.alt)}">';
      });
      html += '</div>';
    }
    var helpfulCount = rev.helpful || 0;
    html += '<button class="tl-rev-helpful" data-found-helpful="' + t('foundHelpful') + '" data-helpful-empty="' + t('helpful') + '">&#128077; <span data-c="' + helpfulCount + '">' + (helpfulCount > 0 ? helpfulCount + ' ' + t('foundHelpful') : t('helpful')) + '</span></button>';
    html += '</div>';
    return html;
  }

  /* ── Main Widget ── */
  function renderWidget(data) {
    var state = {
      sort: 'newest',
      filterStar: 0,
      page: 1
    };

    var container = document.createElement('div');
    container.className = 'tl-reviews';
    container.id = 'tl-reviews-widget';

    function render() {
      var sorted = data.reviews.slice();
      // Sort
      if (state.sort === 'newest') sorted.sort(function(a,b){ return b.date.localeCompare(a.date); });
      if (state.sort === 'highest') sorted.sort(function(a,b){ return b.rating - a.rating || b.date.localeCompare(a.date); });
      if (state.sort === 'lowest') sorted.sort(function(a,b){ return a.rating - b.rating || b.date.localeCompare(a.date); });
      // Filter
      var filtered = state.filterStar > 0 ? sorted.filter(function(r){ return r.rating === state.filterStar; }) : sorted;
      // Paginate
      var totalPages = Math.ceil(filtered.length / PER_PAGE);
      if (state.page > totalPages) state.page = totalPages || 1;
      var start = (state.page - 1) * PER_PAGE;
      var paged = filtered.slice(start, start + PER_PAGE);

      var html = '';
      // Title
      html += '<h2 class="tl-rev-title">' + t('customerReviews') + '</h2>';

      // Summary
      html += '<div class="tl-rev-summary">';
      html += '<div class="tl-rev-score">';
      html += '<div class="tl-rev-score-num">' + data.avg.toFixed(1) + '</div>';
      html += '<div class="tl-rev-score-stars">' + stars(data.avg, 'tl-star--lg') + '</div>';
      html += '<div class="tl-rev-score-count">' + t('basedOn') + ' ' + data.count + ' ' + reviewWord(data.count) + '</div>';
      html += '</div>';
      // Distribution
      html += '<div class="tl-rev-dist">';
      for (var s = 5; s >= 1; s--) {
        var count = data.dist[s] || 0;
        var pct = data.count > 0 ? Math.round(count / data.count * 100) : 0;
        var active = state.filterStar === s ? ' style="font-weight:700"' : '';
        html += '<div class="tl-rev-dist-row" data-star="' + s + '"' + active + '>';
        html += '<span class="tl-rev-dist-label">' + s + ' ' + t('star') + '</span>';
        html += '<div class="tl-rev-dist-bar"><div class="tl-rev-dist-fill" style="width:' + pct + '%"></div></div>';
        html += '<span class="tl-rev-dist-count">' + count + '</span>';
        html += '</div>';
      }
      html += '</div>';
      html += '</div>';

      // Toolbar
      html += '<div class="tl-rev-toolbar">';
      html += '<div class="tl-rev-toolbar-left">' + filtered.length + ' ' + reviewWord(filtered.length) + (state.filterStar > 0 ? ' (' + state.filterStar + ' ' + t('star') + ')' : '') + '</div>';
      html += '<select class="tl-rev-sort" data-action="sort">';
      html += '<option value="newest"' + (state.sort === 'newest' ? ' selected' : '') + '>' + t('newest') + '</option>';
      html += '<option value="highest"' + (state.sort === 'highest' ? ' selected' : '') + '>' + t('highestRated') + '</option>';
      html += '<option value="lowest"' + (state.sort === 'lowest' ? ' selected' : '') + '>' + t('lowestRated') + '</option>';
      html += '</select>';
      html += '</div>';

      // Filter pills
      html += '<div class="tl-rev-filter-pills">';
      html += '<button class="tl-rev-pill' + (state.filterStar === 0 ? ' tl-rev-pill--active' : '') + '" data-filter="0">' + t('all') + '</button>';
      for (var f = 5; f >= 1; f--) {
        var fc = data.dist[f] || 0;
        if (fc > 0) {
          html += '<button class="tl-rev-pill' + (state.filterStar === f ? ' tl-rev-pill--active' : '') + '" data-filter="' + f + '">' + f + '★ (' + fc + ')</button>';
        }
      }
      html += '</div>';

      // Reviews
      if (paged.length === 0) {
        html += '<div class="tl-rev-empty"><div class="tl-rev-empty-icon">📝</div><p>' + t('noReviews') + '</p></div>';
      } else {
        paged.forEach(function(rev) {
          html += reviewCard(rev);
        });
      }

      // Pagination
      if (totalPages > 1) {
        html += '<div class="tl-rev-pagination">';
        html += '<button class="tl-rev-page' + (state.page <= 1 ? ' tl-rev-page--disabled' : '') + '" data-page="' + (state.page - 1) + '">‹</button>';
        for (var p = 1; p <= totalPages; p++) {
          html += '<button class="tl-rev-page' + (state.page === p ? ' tl-rev-page--active' : '') + '" data-page="' + p + '">' + p + '</button>';
        }
        html += '<button class="tl-rev-page' + (state.page >= totalPages ? ' tl-rev-page--disabled' : '') + '" data-page="' + (state.page + 1) + '">›</button>';
        html += '</div>';
      }

      container.innerHTML = html;
      container.setAttribute('aria-busy', 'false');
      bindHelpfulButtons(container);

      // Event bindings
      container.querySelectorAll('[data-star]').forEach(function(el) {
        el.addEventListener('click', function() {
          var s = parseInt(this.dataset.star);
          state.filterStar = state.filterStar === s ? 0 : s;
          state.page = 1;
          render();
        });
      });
      var sortEl = container.querySelector('[data-action="sort"]');
      if (sortEl) {
        sortEl.addEventListener('change', function() {
          state.sort = this.value;
          state.page = 1;
          render();
        });
      }
      container.querySelectorAll('[data-filter]').forEach(function(el) {
        el.addEventListener('click', function() {
          state.filterStar = parseInt(this.dataset.filter);
          state.page = 1;
          render();
        });
      });
      container.querySelectorAll('[data-page]').forEach(function(el) {
        el.addEventListener('click', function() {
          var p = parseInt(this.dataset.page);
          if (p >= 1 && p <= totalPages) {
            state.page = p;
            render();
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    render();
    return container;
  }

  /* ── Price-Area Mini Badge (next to price on PDP) ── */
  function injectPriceReviewBadge(data, root, productUrl) {
    if (!data || !data.count) return;
    root = root || document.querySelector('main') || document;

    // Find the price block container
    var priceBlock = root.querySelector('.product__block--price');
    if (!priceBlock) return;

    // Don't double-inject
    if (priceBlock.querySelector('.tl-pdp-rating')) return;

    var badge = document.createElement('a');
    badge.className = 'tl-pdp-rating';
    badge.href = (productUrl || '') + '#tl-reviews';
      badge.setAttribute('aria-label', data.avg.toFixed(1) + ' ' + t('outOfFive') + ', ' + data.count + ' ' + reviewWord(data.count));
      badge.innerHTML = stars(data.avg, 'tl-star--sm') +
        ' <span class="tl-pdp-rating-avg">' + data.avg.toFixed(1) + '</span>' +
        ' <span class="tl-pdp-rating-count">(' + data.count + ' ' + reviewWord(data.count) + ')</span>';

    badge.addEventListener('click', function(e) {
      if (productUrl) return;
      e.preventDefault();
      var reviewSection = document.querySelector('.tl-reviews-section, .tl-reviews');
      if (reviewSection) {
        reviewSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });

    // Insert after the price div (id="price-..."), within the price block
    var priceDiv = priceBlock.querySelector('[id^="price-"]');
    if (priceDiv) {
      priceDiv.parentNode.insertBefore(badge, priceDiv.nextSibling);
    } else {
      priceBlock.insertBefore(badge, priceBlock.firstChild && priceBlock.firstChild.nextSibling);
    }
  }

  /* ── Inject into Product Page ── */
  function injectProductReviews(data) {
    if (!data || !data.reviews || !data.reviews.length) return;
    if (document.getElementById('tl-reviews')) return;

    createLightbox();

    // Build the widget
    var widget = renderWidget(data);

    // Wrap in a full-width section container for proper layout
    var wrapper = document.createElement('div');
    wrapper.className = 'tl-reviews-section';
    wrapper.id = 'tl-reviews';
    wrapper.style.cssText = 'width:100%;max-width:100%;padding:0 0 40px;';
    var inner = document.createElement('div');
    inner.className = 'page-width';
    inner.appendChild(widget);
    wrapper.appendChild(inner);

    // Strategy: insert AFTER the <product-info> section element (the entire main product block)
    // This places reviews as a standalone section between product info and other sections
    var inserted = false;

    // 1) Best: after <product-info> custom element
    var productInfo = document.querySelector('main product-info:not([data-view-mode="quick-view"])') || document.querySelector('product-info:not([data-view-mode="quick-view"])');
    if (productInfo) {
      productInfo.parentNode.insertBefore(wrapper, productInfo.nextSibling);
      inserted = true;
    }

    // 2) Fallback: after a section with [id*="MainProduct"]
    if (!inserted) {
      var mainSection = document.querySelector('[id*="MainProduct"]');
      if (mainSection) {
        // Walk up to find the section-level parent
        var sectionEl = mainSection.closest('.section') || mainSection;
        sectionEl.parentNode.insertBefore(wrapper, sectionEl.nextSibling);
        inserted = true;
      }
    }

    // 3) Fallback: before testimonials or related products sections
    if (!inserted) {
      var fallbackSections = document.querySelectorAll(
        '[class*="testimonial"], [class*="related-product"], product-recommendations'
      );
      if (fallbackSections.length) {
        fallbackSections[0].parentNode.insertBefore(wrapper, fallbackSections[0]);
        inserted = true;
      }
    }

    // 4) Last resort: append to <main>
    if (!inserted) {
      var main = document.querySelector('main') || document.body;
      main.appendChild(wrapper);
    }
  }

  function injectCardBadges() {
    var slots = document.querySelectorAll('.tl-card-rating[data-product-handle]:not([data-tl-badge-injected="1"])');
    if (!slots.length || !window.TealibereReviewData) return Promise.resolve();
    return window.TealibereReviewData.loadIndex().then(function (index) {
      slots.forEach(function (slot) {
        if (!slot.isConnected || slot.dataset.tlBadgeInjected === '1') return;
        var data = index.products[slot.getAttribute('data-product-handle')];
        if (!data || !data.count || slot.querySelector('.tl-badge-stars')) return;
        var badge = document.createElement('div');
        badge.className = 'tl-badge-stars';
        badge.innerHTML = cardStars(data.avg) + ' <span class="tl-badge-count">(' + data.count + ')</span>';
        slot.innerHTML = '';
        slot.appendChild(badge);
        slot.dataset.tlBadgeInjected = '1';
      });
    });
  }

  function injectQuickViewBadges() {
    var products = document.querySelectorAll('product-info[data-view-mode="quick-view"][data-url]');
    if (!products.length || !window.TealibereReviewData) return Promise.resolve();
    return window.TealibereReviewData.loadIndex().then(function (index) {
      products.forEach(function (product) {
        if (!product.isConnected) return;
        var url = product.getAttribute('data-url');
        var match = url.match(/\/products\/([^?#\/]+)/);
        if (match) injectPriceReviewBadge(index.products[match[1]], product, url);
      });
    });
  }

  /* ── All Reviews Page ── */
  function renderAllReviewsPage(index) {

    var container = document.getElementById('tl-all-reviews');
    if (!container || container.dataset.tlInitialized === '1') return;
    container.dataset.tlInitialized = '1';

    createLightbox();

    var titleTag = document.querySelector('h1') ? 'h2' : 'h1';
    var allData = index.products;
    var handles = Object.keys(allData);
    if (!handles.length) return;

    // Compute global stats
    var totalReviews = 0;
    var totalRatingSum = 0;
    var globalDist = {1:0,2:0,3:0,4:0,5:0};
    handles.forEach(function(h) {
      var d = allData[h];
      totalReviews += d.count;
      totalRatingSum += d.avg * d.count;
      for (var s = 1; s <= 5; s++) globalDist[s] += (d.dist[s] || 0);
    });
    var globalAvg = totalReviews > 0 ? Math.round((totalRatingSum / totalReviews) * 10) / 10 : 0;

    // Sort products by review count desc
    handles.sort(function(a, b) { return allData[b].count - allData[a].count; });

    var state = { selectedHandle: null, sort: 'newest', filterStar: 0, page: 1 };
    var requestNumber = 0;

    async function render() {
      var request = ++requestNumber;
      container.setAttribute('aria-busy', 'true');
      var pageData;
      try {
        pageData = await window.TealibereReviewData.getPage({ handle: state.selectedHandle, sort: state.sort, filterStar: state.filterStar, page: state.page, perPage: 10 });
      } catch (error) {
        if (request !== requestNumber) return;
        container.setAttribute('aria-busy', 'false');
        var failure = container.querySelector('[data-tl-reviews-error]');
        if (!failure) {
          failure = document.createElement('div');
          failure.setAttribute('data-tl-reviews-error', '');
          failure.setAttribute('role', 'status');
          failure.innerHTML = '<p>' + esc(t('loadError')) + '</p><button type="button" class="tl-rev-pill">' + esc(t('retry')) + '</button>';
          failure.querySelector('button').addEventListener('click', render);
          container.appendChild(failure);
        }
        return;
      }
      if (request !== requestNumber || !container.isConnected) return;
      state.page = pageData.page;
      var html = '';

      // Header
      html += '<div class="tl-allrev-header">';
      html += '<' + titleTag + ' class="tl-rev-title" style="font-size:2rem;margin-bottom:0.5rem;">' + t('customerReviews') + '</' + titleTag + '>';
      html += '<div class="tl-allrev-global">';
      html += '<span class="tl-rev-score-num" style="font-size:2.5rem;">' + globalAvg.toFixed(1) + '</span> ';
      html += stars(globalAvg, 'tl-star--lg');
      html += ' <span style="font-size:0.95rem;color:var(--tl-rev-muted);margin-left:8px;">' + totalReviews + ' ' + t('reviewsAcross') + ' ' + handles.length + ' ' + t('products') + '</span>';
      html += '</div>';

      // Global distribution
      html += '<div class="tl-rev-dist" style="max-width:400px;margin:1rem 0;">';
      for (var s = 5; s >= 1; s--) {
        var count = globalDist[s] || 0;
        var pct = totalReviews > 0 ? Math.round(count / totalReviews * 100) : 0;
        html += '<div class="tl-rev-dist-row" data-global-star="' + s + '">';
        html += '<span class="tl-rev-dist-label">' + s + ' ' + t('star') + '</span>';
        html += '<div class="tl-rev-dist-bar"><div class="tl-rev-dist-fill" style="width:' + pct + '%"></div></div>';
        html += '<span class="tl-rev-dist-count">' + count + '</span>';
        html += '</div>';
      }
      html += '</div>';
      html += '</div>';

      // Product selector grid
      html += '<h2 class="tl-rev-title" style="font-size:1.2rem;margin:1.5rem 0 0.75rem;">' + t('browseByProduct') + '</h2>';
      html += '<div class="tl-allrev-products">';
      handles.forEach(function(h) {
        var d = allData[h];
        var name = h.replace(/-/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
        var active = state.selectedHandle === h ? ' tl-allrev-product--active' : '';
        html += '<button class="tl-allrev-product' + active + '" data-handle="' + h + '">';
        html += '<span class="tl-allrev-product-name">' + name + '</span>';
        html += '<span class="tl-allrev-product-rating">' + stars(d.avg, 'tl-star--sm') + ' <span class="tl-badge-count">' + d.avg.toFixed(1) + ' (' + d.count + ')</span></span>';
        html += '</button>';
      });
      html += '</div>';

      var sectionTitle = '';
      if (state.selectedHandle && allData[state.selectedHandle]) {
        var pName = state.selectedHandle.replace(/-/g, ' ').replace(/\b\w/g, function(c){ return c.toUpperCase(); });
        sectionTitle = t('reviewsFor') + ' ' + pName + ' (' + allData[state.selectedHandle].count + ')';
      } else {
        sectionTitle = t('allReviews') + ' (' + totalReviews + ')';
      }
      var totalPages = pageData.totalPages;
      var paged = pageData.reviews;

      html += '<div style="margin-top:2rem;">';
      html += '<div class="tl-rev-toolbar">';
      html += '<div class="tl-rev-toolbar-left" style="font-weight:600;">' + sectionTitle + '</div>';
      html += '<div style="display:flex;gap:8px;align-items:center;">';
      if (state.selectedHandle) {
        var routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root || '/';
        html += '<a href="' + esc(routeRoot) + 'products/' + esc(state.selectedHandle) + '" class="tl-rev-pill" style="text-decoration:none;">' + t('viewProduct') + ' →</a>';
      }
      html += '<select class="tl-rev-sort" data-action="sort-all">';
      html += '<option value="newest"' + (state.sort === 'newest' ? ' selected' : '') + '>' + t('newest') + '</option>';
      html += '<option value="highest"' + (state.sort === 'highest' ? ' selected' : '') + '>' + t('highestRated') + '</option>';
      html += '<option value="lowest"' + (state.sort === 'lowest' ? ' selected' : '') + '>' + t('lowestRated') + '</option>';
      html += '</select></div>';
      html += '</div>';

      // Filter pills
      html += '<div class="tl-rev-filter-pills">';
      html += '<button class="tl-rev-pill' + (state.filterStar === 0 ? ' tl-rev-pill--active' : '') + '" data-afilter="0">' + t('all') + '</button>';
      for (var f = 5; f >= 1; f--) {
        html += '<button class="tl-rev-pill' + (state.filterStar === f ? ' tl-rev-pill--active' : '') + '" data-afilter="' + f + '">' + f + '★</button>';
      }
      html += '</div>';

      if (paged.length === 0) {
        html += '<div class="tl-rev-empty"><div class="tl-rev-empty-icon">📝</div><p>' + t('noReviews') + '</p></div>';
      } else {
        paged.forEach(function(rev) {
          html += reviewCard(rev);
        });
      }

      // Pagination
      if (totalPages > 1) {
        html += '<div class="tl-rev-pagination">';
        html += '<button class="tl-rev-page' + (state.page <= 1 ? ' tl-rev-page--disabled' : '') + '" data-apage="' + (state.page - 1) + '">‹</button>';
        var pages = Array.from(new Set([1, totalPages, state.page - 2, state.page - 1, state.page, state.page + 1, state.page + 2])).filter(function (p) { return p >= 1 && p <= totalPages; }).sort(function (a, b) { return a - b; });
        var previous = 0;
        pages.forEach(function (p) {
          if (previous && p - previous > 1) html += '<span aria-hidden="true">…</span>';
          html += '<button class="tl-rev-page' + (state.page === p ? ' tl-rev-page--active' : '') + '" data-apage="' + p + '">' + p + '</button>';
          previous = p;
        });
        html += '<button class="tl-rev-page' + (state.page >= totalPages ? ' tl-rev-page--disabled' : '') + '" data-apage="' + (state.page + 1) + '">›</button>';
        html += '</div>';
      }
      html += '</div>';

      container.innerHTML = html;
      container.setAttribute('aria-busy', 'false');
      bindHelpfulButtons(container);

      // Bind events
      container.querySelectorAll('[data-handle]').forEach(function(el) {
        el.addEventListener('click', function() {
          var h = this.dataset.handle;
          state.selectedHandle = state.selectedHandle === h ? null : h;
          state.page = 1;
          state.filterStar = 0;
          render();
        });
      });
      container.querySelectorAll('[data-global-star]').forEach(function(el) {
        el.addEventListener('click', function() {
          var s = parseInt(this.dataset.globalStar);
          state.filterStar = state.filterStar === s ? 0 : s;
          state.selectedHandle = null;
          state.page = 1;
          render();
        });
      });
      var sortEl = container.querySelector('[data-action="sort-all"]');
      if (sortEl) {
        sortEl.addEventListener('change', function() {
          state.sort = this.value;
          state.page = 1;
          render();
        });
      }
      container.querySelectorAll('[data-afilter]').forEach(function(el) {
        el.addEventListener('click', function() {
          state.filterStar = parseInt(this.dataset.afilter);
          state.page = 1;
          render();
        });
      });
      container.querySelectorAll('[data-apage]').forEach(function(el) {
        el.addEventListener('click', function() {
          var p = parseInt(this.dataset.apage);
          if (p >= 1 && p <= totalPages) {
            state.page = p;
            render();
            container.scrollIntoView({ behavior: 'smooth', block: 'start' });
          }
        });
      });
    }

    render();
  }

  var observer = null;
  var refreshTimer = null;
  var productRequest = null;

  function loadProductPage() {
    var handle = getHandle();
    if (!handle) return Promise.resolve();
    if (!productRequest) {
      productRequest = window.TealibereReviewData.loadProduct(handle).catch(function (error) {
        productRequest = null;
        throw error;
      });
    }
    return productRequest.then(function (data) {
      if (!data) return;
      injectPriceReviewBadge(data);
      injectProductReviews(data);
    });
  }

  function refresh() {
    var tasks = [injectCardBadges(), injectQuickViewBadges()];
    if (window.location.pathname.indexOf('/products/') !== -1) tasks.push(loadProductPage());
    var allReviews = document.getElementById('tl-all-reviews');
    if (allReviews && allReviews.dataset.tlInitialized !== '1') {
      tasks.push(window.TealibereReviewData.loadIndex().then(renderAllReviewsPage));
    }
    return Promise.allSettled(tasks);
  }

  function scheduleRefresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(refresh, 100);
  }

  function init() {
    if (!window.TealibereReviewData) return Promise.resolve();
    if (!observer && window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        var needsRefresh = mutations.some(function (mutation) {
          return Array.from(mutation.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches('.tl-card-rating, product-info, #tl-all-reviews') || node.querySelector('.tl-card-rating, product-info, #tl-all-reviews'));
          });
        });
        if (needsRefresh) scheduleRefresh();
      });
      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('shopify:section:load', scheduleRefresh);
      document.addEventListener('quick-view:loaded', scheduleRefresh);
    }
    return refresh();
  }

  window.TealibereReviews = {
    init: init,
    injectCardBadges: injectCardBadges,
    getProductData: getProductData,
    openLightbox: openLightbox,
    closeLightbox: closeLightbox
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
